import Auth from './Auth';

export default Auth;


// WEBPACK FOOTER //
// ./src/components/Query/Auth/index.tsx